'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _WAMConstants = require('./constants/WAMConstants');

var _WAMMessageManager = require('./WAMMessageManager');

var _WAMMessageManager2 = _interopRequireDefault(_WAMMessageManager);

var _WAMConnectionManager = require('./WAMConnectionManager');

var _WAMConnectionManager2 = _interopRequireDefault(_WAMConnectionManager);

var _WAMPayloadUtil = require('./util/WAMPayloadUtil');

var _ThorDetectUtil = require('./util/ThorDetectUtil');

var _ThorDetectUtil2 = _interopRequireDefault(_ThorDetectUtil);

var _AnalyticsUtil = require('./util/AnalyticsUtil');

var _AnalyticsUtil2 = _interopRequireDefault(_AnalyticsUtil);

var _CommonUtil = require('./util/CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

var _FFCDataUtil = require('./util/FFCDataUtil');

var _FFCDataUtil2 = _interopRequireDefault(_FFCDataUtil);

var _CompatibilityUtil = require('./util/CompatibilityUtil');

var _CompatibilityUtil2 = _interopRequireDefault(_CompatibilityUtil);

var _GlobalData = require('./util/GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

var _WAMUtil = require('./WAMUtil');

var _WAMUtil2 = _interopRequireDefault(_WAMUtil);

var _WAMErrors = require('./errors/WAMErrors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WAMClient = function () {
	function WAMClient() {
		_classCallCheck(this, WAMClient);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
	}

	_createClass(WAMClient, [{
		key: 'initialize',
		value: function initialize(initConfigJson) {
			var initResult = this.init(initConfigJson);
			if (!initResult.status) {
				return initResult;
			}
			var connectResult = this.attemptConnection(initConfigJson.userContext);
			if (!connectResult.status) {
				return connectResult;
			}
		}
	}, {
		key: 'init',
		value: function init(initConfigJson) {
			var _this = this;

			if (!_GlobalData2.default.ccdDetectPromise) {
				_GlobalData2.default.ccdDetectPromise = this.checkForCCD();
			}
			var initResult = void 0;
			if (_GlobalData2.default.isInitialized) {
				// If config is initialized and client is re-initializing.
				var wamWfTimer = new Date().getTime();
				_GlobalData2.default.addCallbacks(initConfigJson);
				var handleConnected = function handleConnected() {
					if (!initConfigJson.callbacks) {
						return;
					}
					var timeTakenInWAMWF = new Date().getTime() - wamWfTimer;
					initConfigJson.callbacks.onSuccessCallback && initConfigJson.callbacks.onSuccessCallback({ status: true, timeTakenInWAMWF: timeTakenInWAMWF });
					if (initConfigJson.callbacks.onMessageCallback) {
						initConfigJson.callbacks.onMessageCallback(_WAMUtil2.default.getThorApps());
						_this.addListenerForClientMsg(initConfigJson.callbacks.onMessageCallback);
					}
				};
				if (this.isConnected()) {
					// If connection is already established.
					handleConnected();
				} else if (!this.isConnectionInProgress) {
					// If connection was attempted and failed to get established
					var timeTakenInWAMWF = new Date().getTime() - wamWfTimer;
					if (initConfigJson.callbacks && initConfigJson.callbacks.onFailureCallback) {
						if (_GlobalData2.default.thorConnection.error) {
							initConfigJson.callbacks.onFailureCallback({ status: false, error: _GlobalData2.default.thorConnection.error, timeTakenInWAMWF: timeTakenInWAMWF });
						} else {
							initConfigJson.callbacks.onFailureCallback({ status: false, error: _WAMErrors.thorConnection.errors.default, timeTakenInWAMWF: timeTakenInWAMWF });
						}
					}
					initConfigJson.callbacks.onMessageCallback && this.addListenerForClientMsg(initConfigJson.callbacks.onMessageCallback); // if connection is attempted in future
					initResult = { status: false };
				} else {
					initResult = { status: true }; // if connection is established or in progress.
				}
			} else {
				initResult = _GlobalData2.default.initializeContext(initConfigJson);
				if (!initResult.status) {
					if (initConfigJson.callbacks && initConfigJson.callbacks.onFailureCallback) {
						initConfigJson.callbacks.onFailureCallback(initResult);
					}
				}
			}
			_GlobalData2.default.ccdDetectPromise.then(function (isCCDPresent) {
				_GlobalData2.default.callbacks.onCCDDetectionCallbacks && _GlobalData2.default.callbacks.onCCDDetectionCallbacks.forEach(function (onCCDDetectionCallback) {
					onCCDDetectionCallback(isCCDPresent);
				});
			});
			return initResult;
		}
	}, {
		key: 'attemptConnection',
		value: function attemptConnection(userContext) {
			var _this2 = this;

			if (!_GlobalData2.default.isInitialized) {
				if (_GlobalData2.default.callbacks.onFailureCallbacks) {
					_GlobalData2.default.callbacks.onFailureCallbacks.forEach(function (onFailureCallback) {
						onFailureCallback({ status: false, error: _WAMErrors.initialize.errors.wamIsNotInitialized });
					});
				}
				return { status: false, error: _WAMErrors.initialize.errors.wamIsNotInitialized };
			}
			var initResult = _GlobalData2.default.initializeUserContext(userContext);
			if (!initResult.status) {
				if (_GlobalData2.default.callbacks.onFailureCallbacks) {
					_GlobalData2.default.callbacks.onFailureCallbacks.forEach(function (onFailureCallback) {
						onFailureCallback(initResult);
					});
				}
				return initResult;
			}
			if (this.isConnectionInProgress) {
				// to handle the case in which connection is in progress.
				return { status: true };
			}
			this.isConnectionInProgress = true;
			var wamWfTimer = new Date().getTime();
			_WAMUtil2.default.initThorConnection({
				timeout: _WAMConstants.wamTimeouts.thorConnectionTimeoutOnPageLoad,
				disconnectConn: true
			}).then(function (isThorConnectedForInline) {
				_this2.isConnectionInProgress = false;
				var timeTakenInWAMWF = new Date().getTime() - wamWfTimer;
				if (isThorConnectedForInline) {
					if (_GlobalData2.default.callbacks.onSuccessCallbacks) {
						_GlobalData2.default.callbacks.onSuccessCallbacks.forEach(function (onSuccessCallback) {
							onSuccessCallback({ status: true, timeTakenInWAMWF: timeTakenInWAMWF });
						});
					}
					if (_GlobalData2.default.callbacks.onMessageCallbacks) {
						_GlobalData2.default.callbacks.onMessageCallbacks.forEach(function (onMessageCallback) {
							onMessageCallback(_WAMUtil2.default.getThorApps());
							_this2.addListenerForClientMsg(onMessageCallback);
						});
					}
				} else {
					if (_GlobalData2.default.callbacks.onFailureCallbacks) {
						_GlobalData2.default.callbacks.onFailureCallbacks.forEach(function (onFailureCallback) {
							if (_GlobalData2.default.thorConnection.error) {
								onFailureCallback({ status: false, error: _GlobalData2.default.thorConnection.error, timeTakenInWAMWF: timeTakenInWAMWF });
							} else {
								onFailureCallback({ status: false, error: _WAMErrors.thorConnection.errors.default, timeTakenInWAMWF: timeTakenInWAMWF });
							}
						});
					}
					if (_GlobalData2.default.callbacks.onMessageCallbacks) {
						// if connection is attempted in future
						_GlobalData2.default.callbacks.onMessageCallbacks.forEach(function (onMessageCallback) {
							_this2.addListenerForClientMsg(onMessageCallback);
						});
					}
				}
			});
			return { status: true };
		}
	}, {
		key: 'sendCommand',
		value: function sendCommand(cmdContext) {
			var _this3 = this;

			var validate = function validate(cmdContext) {
				if (!cmdContext) {
					return { status: false, error: _WAMErrors.command.errors.cmdContextUndefined };
				}
				if (!cmdContext.sapCode) {
					return { status: false, error: _WAMErrors.command.errors.sapcodeUndefined };
				}
				if (!cmdContext.version) {
					return { status: false, error: _WAMErrors.command.errors.versionUndefined };
				}
				if (cmdContext.isConfirmationType) {
					if (!cmdContext.confirmationId) {
						return { status: false, error: _WAMErrors.command.errors.confirmationIdUndefined };
					}
					if (!cmdContext.confirmationType) {
						return { status: false, error: _WAMErrors.command.errors.confirmationTypeUndefined };
					}
				} else {
					if (!cmdContext.commandPayload) {
						return { status: false, error: _WAMErrors.command.errors.commandPayloadUndefined };
					}
					if (!cmdContext.commandPayload.command) {
						return { status: false, error: _WAMErrors.command.errors.commandUndefined };
					}
					if (!_WAMConstants.ccHomeCommands.ccHomeToThorCommands[cmdContext.commandPayload.command]) {
						return { status: false, error: _WAMErrors.command.errors.commandNotSupported };
					}
				}
				return { status: true };
			};

			var pushCmd = function pushCmd(cmdContext, resolve, reject) {
				if (!_WAMConnectionManager2.default.currentDevice || !_WAMConnectionManager2.default.currentDevice.deviceId) {
					reject({ status: false, error: _WAMErrors.command.errors.currentDeviceNotFound });
					return;
				}
				var payloadForCmd = void 0;
				if (cmdContext.isConfirmationType) {
					payloadForCmd = (0, _WAMPayloadUtil.getPayloadForConfirmation)({
						userId: _GlobalData2.default.userContext.userId,
						deviceId: _WAMConnectionManager2.default.currentDevice.deviceId,
						sapCode: cmdContext.sapCode,
						version: cmdContext.version,
						confirmationID: cmdContext.confirmationId,
						confirmationType: cmdContext.confirmationType,
						confirmationValue: cmdContext.confirmationBtnVal,
						confirmationCheckboxes: cmdContext.confirmationCheckboxes,
						ingestContext: cmdContext.ingestContext
					});
				} else {
					payloadForCmd = (0, _WAMPayloadUtil.getPayloadForCmds)({
						userId: _GlobalData2.default.userContext.userId,
						deviceId: _WAMConnectionManager2.default.currentDevice.deviceId,
						sapCode: cmdContext.sapCode,
						version: cmdContext.version,
						commandPayload: cmdContext.commandPayload,
						ingestContext: cmdContext.ingestContext
					});
				}
				_WAMMessageManager2.default.clearAnalyticsRepo(cmdContext.sapCode, cmdContext.version);
				_WAMUtil2.default.printLog('Command: ' + JSON.stringify(payloadForCmd));
				_WAMMessageManager2.default.sendMsg(_WAMConstants.wamEvents.sendEvents.clientMsg, payloadForCmd);
				resolve(true);
			};
			return new Promise(function (resolve, reject) {
				var returnResult = validate(cmdContext);
				if (!returnResult.status) {
					reject(returnResult);
					return;
				}
				if (_this3.isConnected()) {
					pushCmd(cmdContext, resolve, reject);
				} else {
					// explicitly doing CCD detection if WAM is disconnected due to idle timeout.
					_GlobalData2.default.ccdDetectPromise = _this3.checkForCCD();
					_WAMUtil2.default.initThorConnection({
						timeout: _WAMConstants.wamTimeouts.thorConnectionTimeoutOnCmdExecution,
						isLongWaitingEnabled: false
					}).then(function (isThorConnectedForInline) {
						if (isThorConnectedForInline) {
							pushCmd(cmdContext, resolve, reject);
						} else {
							if (_GlobalData2.default.thorConnection.error) {
								reject({ status: false, error: _GlobalData2.default.thorConnection.error });
							} else {
								reject({ status: false, error: _WAMErrors.thorConnection.errors.default });
							}
						}
					});
				}
			});
		}
	}, {
		key: 'connect',
		value: function connect(wamConnectConfig) {
			var _this4 = this;

			return new Promise(function (resolve) {
				if (_this4.isConnected()) {
					resolve(true);
					return;
				} else {
					_WAMUtil2.default.initThorConnection(wamConnectConfig).then(function (isThorConnectedForInline) {
						resolve(isThorConnectedForInline);
					});
				}
			});
		}

		/**
   * Checks if product is compatible with given user OS
   *
   * @param sapCode (Required param) Sapcode of product whose update description is to be fetched
   * @param version (Required param) Version of product whose update description is to be fetched
   * @param env (Required param) Environment such as local, dev, qe, stage, prod
   * @param platform
   * @param locale
   */

	}, {
		key: 'getUpdateDescription',
		value: function getUpdateDescription(_ref) {
			var sapCode = _ref.sapCode,
			    version = _ref.version,
			    env = _ref.env,
			    platform = _ref.platform,
			    xAdobeAppId = _ref.xAdobeAppId,
			    locale = _ref.locale;

			return _FFCDataUtil2.default.getUpdateDecription({ sapCode: sapCode, version: version, env: env, platform: platform, xAdobeAppId: xAdobeAppId, locale: locale });
		}

		/**
   * Checks if product is compatible with given user OS based on the sapcode and ffc data
   * @param sapCode
   * @param allVersionFFCData
   * @returns {*}
   */

	}, {
		key: 'checkCompatibilityViaFFC',
		value: function checkCompatibilityViaFFC(sapCode, allVersionFFCData) {
			var error = _WAMConstants.compatibilityStrings.error;

			if (!sapCode || !allVersionFFCData) {
				return error;
			}
			return _CompatibilityUtil2.default.setFFCDataAndCheckCompatibility(sapCode, allVersionFFCData);
		}

		/**
   * Checks if product is compatible with given user OS
   *
   * @param sapCode (Required param) Sapcode of product whose compatibility is to be checked
   * @param env (Required param) Environment such as local, dev, qe, stage, prod
   * @param clientId (Required param)
   * @param platform
   * @param accessToken
   * @param appId
   * @param allVersionFFCData (Optional Param) Client can pass all version FFC
   * data if already fetched
   * @returns Promise to fetch FFC data (and find compatibility info) which can resolve to following states:
   * 1. 'currentSupported': Latest version of product supported
   * 2. 'previousSupported': Previous version supported along with version number
   * 3. 'incompatible': Incompatible OS
   */

	}, {
		key: 'checkCompatibility',
		value: function checkCompatibility(_ref2) {
			var sapCode = _ref2.sapCode,
			    env = _ref2.env,
			    clientId = _ref2.clientId,
			    platform = _ref2.platform,
			    accessToken = _ref2.accessToken,
			    appId = _ref2.appId,
			    allVersionFFCData = _ref2.allVersionFFCData;
			var error = _WAMConstants.compatibilityStrings.error;

			return new Promise(function (resolve, reject) {
				if (!sapCode || !env || !clientId) {
					reject(error);
				}
				var platformList = ['osx10', 'osx10-64', 'win32', 'win64'];
				platform = platformList.includes(platform) ? platform : platformList.join(',');
				_FFCDataUtil2.default.getFFCData({ sapCode: sapCode, platform: platform, env: env, accessToken: accessToken, clientId: clientId, appId: appId, allVersionFFCData: allVersionFFCData }).then(function (appData) {
					if (!appData) {
						reject(error);
					} else {
						var result = _CompatibilityUtil2.default.setFFCDataAndCheckCompatibility(sapCode, appData);
						resolve(result);
					}
				}).catch(function (e) {
					reject(error);
				});
			});
		}
	}, {
		key: 'checkForCCD',
		value: function checkForCCD(env, verifyCCDPresence, args) {
			if (!verifyCCDPresence && _GlobalData2.default.ccdDetectPromise) {
				return _GlobalData2.default.ccdDetectPromise;
			}
			var ccdDetectTimer = new Date().getTime();
			var ccdDetectPromise = _ThorDetectUtil2.default.checkForThor(args);
			var enviroment = env || _GlobalData2.default.env;
			ccdDetectPromise.then(function (isCCDPresent) {
				if (enviroment) {
					var timeTakenInDetection = new Date().getTime() - ccdDetectTimer;
					_AnalyticsUtil2.default.sendAnalyticsOnCCDDetection(isCCDPresent, timeTakenInDetection, env);
				}
			});
			_GlobalData2.default.ccdDetectPromise = ccdDetectPromise;
			return ccdDetectPromise;
		}
	}, {
		key: 'launchCCDUI',
		value: function launchCCDUI(_ref3) {
			var verifyCCDPresence = _ref3.verifyCCDPresence,
			    env = _ref3.env,
			    aamUrl = _ref3.aamUrl,
			    paramPrefix = _ref3.paramPrefix,
			    failureCallback = _ref3.failureCallback;

			var FFCENV = env || _GlobalData2.default.env;
			if (!FFCENV || !_WAMConstants.FFCUrls.products[FFCENV]) {
				failureCallback && failureCallback('env is not set');
				return;
			}
			var openCCD = function openCCD() {
				_CommonUtil2.default.getFFCPassphrase(FFCENV).then(function (passphrase) {
					if (!passphrase && failureCallback) {
						failureCallback('passphrase_not_available');
						return;
					}
					var url = 'aam://passPhrase=' + passphrase + '?actionList=CC-UI';
					if (aamUrl) {
						var delimiter = '?';
						if (_ThorDetectUtil2.default.aamPluginSupportsAmpersand() && aamUrl.indexOf('?') >= 0) {
							delimiter = '&';
						}
						if (paramPrefix) {
							delimiter = paramPrefix;
						}
						url = '' + aamUrl.replace(/\/$/, '') + delimiter + 'passPhrase=' + passphrase + delimiter + 'actionList=CC-UI';
					}
					window.open(url, '_parent');
				});
			};

			if (verifyCCDPresence) {
				_ThorDetectUtil2.default.checkForThor().then(function (isThorPresent) {
					if (isThorPresent) {
						openCCD();
					} else {
						failureCallback && failureCallback('CCD is not present');
					}
				});
			} else {
				openCCD();
			}
		}
	}, {
		key: 'launchCCProductByCCD',
		value: function launchCCProductByCCD(_ref4) {
			var env = _ref4.env,
			    failureCallback = _ref4.failureCallback,
			    sapcode = _ref4.sapcode,
			    version = _ref4.version;

			var FFCENV = env || _GlobalData2.default.env;
			if (!FFCENV || !_WAMConstants.FFCUrls.products[FFCENV]) {
				failureCallback && failureCallback('env is not set');
				return;
			}
			_ThorDetectUtil2.default.checkForThor().then(function (isThorPresent) {
				if (isThorPresent) {
					_CommonUtil2.default.getFFCPassphrase(FFCENV).then(function (passphrase) {
						if (!passphrase && failureCallback) {
							failureCallback('passphrase_not_available');
							return;
						}
						var url = 'aam://SAPCode=' + sapcode;
						var delimiter = '?';
						if (version) {
							url = '' + url + delimiter + 'version=' + version;
							if (_ThorDetectUtil2.default.aamPluginSupportsAmpersand()) {
								delimiter = '&';
							}
							url = '' + url + delimiter + 'checkPrevious=true';
						}
						url = '' + url + delimiter + 'passPhrase=' + passphrase + delimiter + 'actionList=CC-UI';
						window.open(url, '_parent');
					});
				} else {
					failureCallback && failureCallback('CCD is not present');
				}
			});
		}
	}, {
		key: 'addListenerForClientMsg',
		value: function addListenerForClientMsg(onMessageCallback) {
			_WAMUtil2.default.addListenerForClientMsg(onMessageCallback);
		}

		/** To remove Listener when ClientMsg arrives **/

	}, {
		key: 'removeListenerForClientMsg',
		value: function removeListenerForClientMsg(onMessageCallback) {
			_WAMUtil2.default.removeListenerForClientMsg(onMessageCallback);
		}

		/** To add Listener when ClientState arrives **/

	}, {
		key: 'addListenerForClientState',
		value: function addListenerForClientState(onClientStateCallback) {
			_WAMUtil2.default.addListenerForClientState(onClientStateCallback);
		}

		/** To remove Listener when ClientState arrives **/

	}, {
		key: 'removeListenerForClientState',
		value: function removeListenerForClientState(onClientStateCallback) {
			_WAMUtil2.default.removeListenerForClientState(onClientStateCallback);
		}
	}, {
		key: 'getProduct',
		value: function getProduct(sapCode, version) {
			return _WAMMessageManager2.default.getProduct(_WAMMessageManager2.default.products, sapCode, version);
		}
	}, {
		key: 'getProductsList',
		value: function getProductsList() {
			return _WAMUtil2.default.getThorApps();
		}
	}, {
		key: 'getInstalledProduct',
		value: function getInstalledProduct(sapcode) {
			var product = void 0;
			if (sapcode && this.isConnected()) {
				var productsList = this.getProductsList();
				product = productsList.installed.filter(function (ele) {
					return ele.sapcode && ele.sapcode.toUpperCase() === sapcode.toUpperCase();
				})[0];
				if (!product) {
					var updatableProduct = productsList.available_updates.filter(function (ele) {
						return ele.sapcode && ele.sapcode.toUpperCase() === sapcode.toUpperCase();
					})[0];
					var updateTypes = {
						patchUpdate: 'PatchUpdate',
						fullBuildUpdate: 'FullBuildUpdate'
					};
					if (updatableProduct && (updatableProduct.update_type === updateTypes.fullBuildUpdate || updatableProduct.update_type === updateTypes.patchUpdate)) {
						product = updatableProduct;
					}
				}
			}
			return product;
		}
	}, {
		key: 'launchProduct',
		value: function launchProduct(sapcode) {
			var product = this.getInstalledProduct(sapcode);
			if (product) {
				this.sendCommand({
					sapCode: product.sapcode,
					version: product.version,
					commandPayload: {
						command: 'launch'
					}
				});
				return true;
			}
			return false;
		}
	}, {
		key: 'isConnected',
		value: function isConnected() {
			return _WAMUtil2.default.areClientsConnected();
		}
	}, {
		key: 'isThorAppsPanelEnabled',
		value: function isThorAppsPanelEnabled() {
			return _WAMUtil2.default.isThorAppsPanelEnabled();
		}
	}, {
		key: 'reset',
		value: function reset() {
			_WAMMessageManager2.default.resetThorAppsState();
			_WAMMessageManager2.default.resetThorAppList();
		}
	}, {
		key: 'disconnect',
		value: function disconnect() {
			_WAMConnectionManager2.default.disconnect();
		}
	}]);

	return WAMClient;
}();

exports.default = WAMClient;

if (window && window.WAMClient) {
	module.exports = window.WAMClient;
} else {
	var wamClient = new WAMClient();
	if (window) {
		window.WAMClient = wamClient;
	}
	module.exports = wamClient;
}